import { render, staticRenderFns } from "./AttendanceRulesEditor.vue?vue&type=template&id=583da2ea&scoped=true&"
import script from "./AttendanceRulesEditor.vue?vue&type=script&lang=js&"
export * from "./AttendanceRulesEditor.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceRulesEditor.vue?vue&type=style&index=0&id=583da2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583da2ea",
  null
  
)

export default component.exports